// extracted by mini-css-extract-plugin
export default {"attentionContainer":"RescheduleOrCancelChoice--attentionContainer--175061","button":"RescheduleOrCancelChoice--button--5f3976"};